import React from 'react';
import ParticipantForm from '../../../components/participant/participant-form';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as participantActions from '../../../actions/participant';
import Loading from '../../../components/loading';
import AdminItemPageContainer from '../admin-item-page-container';
class PartnerContainer extends AdminItemPageContainer {

    getBaseUrl() {
        return '/admin/participants';
    }

    fetchItem(id) {
        return this.props.actions.fetchParticipant(id)
    }

    render() {
        const {actions, loading} = this.props;

        return (
            <div className="panel">
                <header className="panel-header">Participant edit</header>
                <div className="panel-body">
                    {loading
                        ? <Loading/>
                        : <ParticipantForm submit={actions.submitParticipant} onSuccessSubmit={this.onSuccessSubmit.bind(this)} displayPayed={true}></ParticipantForm>
}
                </div>
            </div>
        )

    }
}

export default connect(function(state) {
    return {loading: state.participant.loading};
}, function(dispatch) {
    return {
        actions: bindActionCreators({
            ...participantActions
        }, dispatch)
    };
})(PartnerContainer);



// WEBPACK FOOTER //
// ./src/js/containers/admin/participant/participant-container.js